import { useTranslation } from 'next-i18next';
import { NotificationChannel } from '../../types';
import * as yup from 'yup';

export const useCheckoutContactSchema = () => {
    const { t } = useTranslation('auth');

    return yup.object({
        otpChannel: yup
            .mixed<NotificationChannel>()
            .oneOf([NotificationChannel.Sms, NotificationChannel.Zalo])
            .required(t('text_select_otp_method')),
    });
};
